import { call } from "redux-saga/effects";
import { authApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import { WorkCompanyContextDto } from "../../../../../dto/User/WorkCompanyDto";
import endPoints from "./workCompany.endpoints";
import { SwitchWorkCompanyRequestDto } from "./workCompany.requestsDto";

const workCompanyApi = {
  switchCompany: function* (dto: SwitchWorkCompanyRequestDto) {
    return (yield call([authApiService, authApiService.Post], endPoints.switchCompany, dto)) as ApiCallResult<WorkCompanyContextDto>;
  },
};

export default workCompanyApi;
